import React, { useEffect, useState } from "react";
import LineGraph from "../LineGraph/LineGraph";
import useFetch from "../Hooks/use-fetch";
import styles from "./Graph.module.css";
import { getCryptoPrice } from "../../services/api";
import AdvancedRealTimeChartComponent from "./TradingView";

const url = "https://api.coingecko.com/api/v3/coins/link/market_chart?vs_currency=usd&days=";
const currencyName = "ChainLink";
const currencySymbol = "LINK";
const ChainLinkGraph = () => {
  //State to update any fetch errors
  const [error, setError] = useState();
  const [date, setDate] = useState(Date);
  const [LINKPrice, setLINKPrice] = useState() as any;
  const [LINKPriceChange, setLINKPriceChange] = useState() as any;
  //Custom Hook for Fetching Data using Fetch API
  const {
    yearClickHandler,
    monthClickHandler,
    weekClickHandler,
    dayClickHandler,
    hourClickHandler,
    value: data,
    api,
  } = useFetch();

  useEffect(() => {
    setDate(Date);
    getLINKCoinPrice();
    api(url).catch((error) => {

      setError(error.message);
    });
  }, [api]);

  const getLINKCoinPrice = async () => {
    const res = await getCryptoPrice('LINK');
    setLINKPrice(res.data.lastPrice);
    setLINKPriceChange(res.data.priceChangePercent)
  }

  return (
    <React.Fragment>
      {/* {!error ? (
        <LineGraph
          currencyName={currencyName}
          yearClickHandler={yearClickHandler}
          monthClickHandler={monthClickHandler}
          weekClickHandler={weekClickHandler}
          dayClickHandler={dayClickHandler}
          hourClickHandler={hourClickHandler}
          data={data}
          date={date}
          currencyPrice={LINKPrice}
          currencyPriceChange={LINKPriceChange}
          currencySymbol={currencySymbol}
        />
      ) : (
        <div className={styles.error}>
          <h5>{error}</h5>
        </div>
      )} */}
      <AdvancedRealTimeChartComponent coin={"LINK"} />
    </React.Fragment>
  );
};

export default ChainLinkGraph;
